export enum ViewMode {
    TABLE = 'table',
    BAR_CHART = 'barChart',
    WATCHLIST = 'watchlist'
}
